"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escape = escape;
exports.falseNotZero = falseNotZero;
exports.formatPhoneNumber = void 0;
exports.guid = guid;
exports.inertAttr = void 0;
exports.isFunction = isFunction;
exports.isObject = isObject;
exports.isReactChildrenHasContent = void 0;
exports.isUrl = isUrl;
exports.preventDefault = preventDefault;
exports.stopEventPropagation = exports.roundToDecimal = void 0;
var stopEventPropagation = exports.stopEventPropagation = function stopEventPropagation(e) {
  // disable pasting block when block is copied to clipboard
  e.stopPropagation();
};
function preventDefault(e) {
  e.preventDefault();
}
function falseNotZero(value) {
  return !value && value !== 0;
}
var isReactChildrenHasContent = exports.isReactChildrenHasContent = function isReactChildrenHasContent(children) {
  return Array.isArray(children) ? !children.every(falseNotZero) : !falseNotZero(children);
};
function isFunction(fn) {
  return typeof fn === 'function';
}
function isObject(obj) {
  return obj instanceof Object;
}
function isUrl(str) {
  return str ? !!str.match(/^https?:\//) : false;
}
function guid() {
  var s4 = function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  };
  //return id of format 'aaaaaaaa'-'aaaa'-'aaaa'-'aaaa'-'aaaaaaaaaaaa'
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"']/g;
var reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @since 0.1.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @see escapeRegExp, unescape
 * @example
 *
 * escape('fred, barney, & pebbles')
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, function (chr) {
    return htmlEscapes[chr];
  }) : string || '';
}
var formatPhoneNumber = exports.formatPhoneNumber = function formatPhoneNumber(value) {
  // return nothing if no value
  if (!value) {
    return value;
  }

  // only allows 0-9 inputs
  var currentValue = value.replace(/[^\d]/g, '');
  var cvLength = currentValue.length;
  if (cvLength > 0) {
    // returns: "(xxx)", "(xxx) x", "(xxx) xx", "(xxx) xxx",
    if (cvLength > 3 && cvLength < 7) {
      return "(".concat(currentValue.slice(0, 3), ") ").concat(currentValue.slice(3));
    }
    if (cvLength > 6) {
      // returns: "(xxx) xxx-", (xxx) xxx-x", "(xxx) xxx-xx", "(xxx) xxx-xxx", "(xxx) xxx-xxxx"
      return "(".concat(currentValue.slice(0, 3), ") ").concat(currentValue.slice(3, 6), "-").concat(currentValue.slice(6, 15));
    }
  }
  return currentValue;
};
var roundToDecimal = exports.roundToDecimal = function roundToDecimal(num, decimal) {
  var decimalValue = Math.pow(10, decimal);
  return Math.round(num * decimalValue) / decimalValue;
};
var inertAttr = exports.inertAttr = function inertAttr(_ref) {
  var inert = _ref.inert;
  return {
    inert: inert ? 'true' : undefined
  };
};
//# sourceMappingURL=shared.utils.js.map